export default __webpack_public_path__ + "static/media/1.f4b0a52b.png";